import dynamic, { DynamicOptions } from 'next/dynamic'
import { logger } from '@/utils/logging'
import type { PifExplainerVideoPlayerProps } from './types'

export const PifExplainerVideoPlayer = dynamic(
  import('./PifExplainerVideoPlayer')
    .then((mod) => mod.PifExplainerVideoPlayer)
    .catch((err) =>
      logger().error(`Failed to load the PifExplainerVideoPlayer!`, err),
    ) as DynamicOptions<PifExplainerVideoPlayerProps>,
  { ssr: false },
)
